const Modal = import('bootstrap/js/dist/modal');
const OffCanvas = import('bootstrap/js/dist/offcanvas');
const Collapse = import('bootstrap/js/dist/collapse');

export default defineNuxtPlugin(async (nuxtApp) => {
    // nuxtApp.provide('bootstrap', bootstrap)
    window.__MODAL__ = (await Modal).default;
});
